export default "__VITE_ASSET__BXvLapPo__"